<template>
  <div>
    <b-row style="margin-top: 10px">
      <b-col>
        <b-icon
            icon="tropical-storm"
            scale="1.5"
            variant="dark"
            @click="handleFeedbackThumbsUp(true)"
            style="cursor:pointer;"
        />
      </b-col>
    </b-row>
    <b-modal
        :id="modalId"
        hide-backdrop
        content-class="shadow"
        title="Provide Additional Comments">
      <p class="my-2">
        Please review and approve the card for this heartbeat.
      </p>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "HeartBeat_CarePlan_Block_Feedback",
  components: {},
  created(){},
  beforeMount() {},
  mounted() {},
  props: {
    feedBackQuestion: {
      type: Object,
      default: () => {
        return {
          key: "beneficial",
          question:"Was this helpful?"
        }
      }
    },
    heartbeat: {
      type: Object,
      default: () => {
        return {};
      }
    },
    info: {
      type: Array,
      default: () => {
        return [];
      }
    },
    profile: {
      type: Object,
      default: () => {
        return {};
      }
    },
    doc: {
      type: Object,
      default: () => {
        return {};
      }
    },
    apps: {
      type: Array,
      required: true,
      default: () => {
        return [];
      }
    },
    sectionId: {
      type: String,
      default: 'none'
    },
    planId: {
      type: String,
      default: 'none'
    },
  },
  computed: {
    ...mapGetters({}),
    providerId() {
      return this.profile && this.profile.userId ? this.profile.userId : null;
    },
    docId() {
      return this.doc && this.doc.id ? this.doc.id : null;
    },
    modalId() {
      return `feedback-modal-id-${this.doc && this.doc.id ? this.doc.id : 0}-${this.sectionId}`;
    }
  },
  methods: {
    handleFeedbackThumbsUp(isLiked){
      //Update Feedback
      //PopUp Modal for Additional Comments
      this.addFeedbackThumbsUp(isLiked);
     // this.$bvModal.show(this.modalId);
    },
    addFeedbackThumbsUp(isLiked) {
      const profileBy = this.profileBy();

      const feedback = {
        isLiked: isLiked,
        _created_by: profileBy,
        _created_at: new Date()
      };

      if (this.comment) feedback.comment = this.comment;

      this.$store
          .dispatch("provider/addSectionTrackForProviderIdPlanIdDocId", {
            sectionId:  this.sectionId,
            trackProperty: 'feedbacks',
            payload: feedback,
            providerId: this.providerId,
            planId: this.planId,
            docId: this.docId,
            updatedBy:{}
          })
          .then(({ length }) => {
            if (length) {
              this.maxcp = length;
              this.cpIdx = length - 1;
            }
          })
          .catch(err => {});
    },
    profileBy() {
      return {
        uid: this.profile && this.profile.userId ? this.profile.userId : null,
        name: this.profile
            ? `${this.profile.firstname} ${this.profile.lastname}`
            : null,
        imgURL: this.profile ? this.profile.imgURL : null,
        comment: null
      }
    }
  },
  data() {
    return {
    };
  }
};
</script>

<style lang="scss" scoped>
.container .vue-grid-item.vue-grid-placeholder {
  background: #c0c081;
}
</style>